import React, { useState, useEffect } from "react";
import SectionTitle from "../component/SectionTitle";
import Sidebar from "../component/Sidebar";
import LoaderSpinner from "../component/LoaderSpinner";
import ReactHtmlParser from "react-html-parser";

export default function Cms_Details(props) {
  const [cmsDetail, setCmsDetail] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const id = props.match.params.id;
    
    if (id) {
      axios.post("api/get_other_cms_detail", { id: id }, { signal: controller.signal }).then((res) => {
        if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setCmsDetail(res.data.data);
        } else {
          setCmsDetail([]);
        }
        // setLoading(false);
      }).catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load CMS details:", error);
        }
      });
    }

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <section className="pf-details">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="single-content">
              <h4>{cmsDetail.title}</h4>
              <figure>
                <img src={cmsDetail.imgUrl} alt={cmsDetail.title} />
              </figure>
              {ReactHtmlParser(cmsDetail.description)}
            </div>
          </div>
          <Sidebar />
          <div className="clearfix" />
        </div>
      </div>
    </section>
  );
}
